import {
  URLAAlternateName,
  URLAAlternateNameActionType,
} from 'src/components/Loan/Application/Sections/BorrowerInfo/Inputs/AlternateNames/store/types';

type AlternateNameStore = URLAAlternateName[];

const defaultState: AlternateNameStore = [];

const reducer = (
  state: AlternateNameStore = defaultState,
  { type, data }: { type: URLAAlternateNameActionType; data: any },
): AlternateNameStore => {
  switch (type) {
    // @ts-ignore
    case 'clear_loan_data':
      return defaultState;
    case URLAAlternateNameActionType.SET: {
      const items = [...state];
      for (const item of data) {
        const matchIndex = state.findIndex((x) => x.id === item.id);
        if (matchIndex > -1) {
          items.splice(matchIndex, 1, {
            ...items[matchIndex],
            ...item,
          });
        } else {
          items.push(item);
        }
      }
      return items;
    }
    case URLAAlternateNameActionType.UPDATE: {
      const matchIndex = state.findIndex((x) => x.id === data.id);
      const items = [...state];

      items.splice(matchIndex, 1, {
        ...items[matchIndex],
        ...data,
      });
      return items;
    }
    case URLAAlternateNameActionType.ADD: {
      const items = [...state, data];
      return items;
    }
    case URLAAlternateNameActionType.DELETE: {
      const matchIndex = state.findIndex((x) => x.id === data);
      const items = [...state];
      items.splice(matchIndex, 1);
      return items;
    }
    default:
      return state;
  }
};

export default reducer;
